module.exports = __webpack_public_path__ + "static/media/JINGLE_RAFFLE.2db0c7d2.mp3";